import { useTranslation } from 'react-i18next';

import { DataPanelItem, NgCopyButton } from '@/ui';
import { PhoneNumber } from '@ngsos/portal-core/incidents';
import type { EmergencyContact } from '@/signalr';

export type ClosePersonContactPanelItemProps = {
  contacts: readonly EmergencyContact[];
};

export function ClosePersonContactPanelItem({ contacts }: ClosePersonContactPanelItemProps) {
  const { t } = useTranslation();

  if (contacts.length === 0) {
    return null;
  }

  return (
    <DataPanelItem title={t('Incident_InfoPanel_ClosePersonContact')}>
      {contacts.map((contact) => {
        const parsed = PhoneNumber.tryInitialize(contact.phoneNumber);
        const formatted = parsed?.toFormattedString() ?? contact.phoneNumber;
        return (
          <div key={`${contact.name}-${contact.phoneNumber}`} className="d-flex justify-content-between align-items-center">
            <div className="medium">{contact.name}</div>
            <div className="d-flex align-items-center medium">
              <div>
                <a href={parsed?.getUrlForCall() ?? `tel:${contact.phoneNumber}`}>{formatted}</a>
              </div>
              <NgCopyButton valueToCopy={formatted} cssClass="p-1" />
            </div>
          </div>
        );
      })}
    </DataPanelItem>
  );
}
